var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKbc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 82,
    viewBox: "0 0 100 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5205 36.4022C60.0129 36.4022 67.708 28.3831 67.708 18.491C67.708 8.59894 60.0129 0.579834 50.5205 0.579834C41.0281 0.579834 33.333 8.59894 33.333 18.491C33.333 28.3831 41.0281 36.4022 50.5205 36.4022Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.5277C0 40.5277 16.4051 37.443 32.8352 35.337C36.6279 38.5811 41.4811 40.5284 46.7707 40.5284C53.2925 40.5284 59.1509 37.5682 63.1761 32.8669C81.1016 32.06 100 31.8435 100 31.8435V48.3435H0V40.5277Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8378 71.6625V81.277H0V55.7874H11.8378V67.2465H11.8919L18.8649 55.7874H33.027L22.6486 68.9235L32.4324 81.2211H18.9189L11.8919 71.6625H11.8378Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.568 80.2156C96.7572 81.11 93.1356 81.613 89.8383 81.613C78.1626 81.613 69.568 78.1473 69.568 68.1974C69.568 59.1419 77.8923 55.229 89.2977 55.229C92.4869 55.229 96.4869 55.5644 99.6221 56.6265V65.4025C97.2978 63.9492 94.9734 63.0548 91.6221 63.0548C87.2977 63.0548 82.9194 65.2907 82.9194 68.4769C82.9194 71.719 87.2437 73.8991 91.6221 73.8991C94.9194 73.8991 97.2978 72.9488 99.6221 71.5513L99.568 80.2156Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9725 55.7874H58.8644C65.0807 55.7874 67.1347 58.3028 67.1347 62.1598C67.1347 66.5198 63.3509 68.4204 59.5131 68.5881V68.644C63.459 68.9794 67.3509 69.4266 67.3509 74.5692C67.3509 77.9231 65.2969 81.2211 58.4861 81.2211H34.9725V55.7874ZM46.8104 76.0785H52.9725C55.2969 76.0785 56.0536 75.0723 56.0536 73.6189C56.0536 72.1656 55.2428 71.1035 52.9725 71.1035H46.7563L46.8104 76.0785ZM46.8104 66.5757H52.7023C54.9725 66.5757 55.8915 65.6255 55.8915 64.1721C55.8915 62.4952 54.9725 61.6567 52.8644 61.6567H46.8104V66.5757Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbc);
export default __webpack_public_path__ + "static/media/KBC.42317e14bdade35e0e7508829c40ff88.svg";
export { ForwardRef as ReactComponent };